import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import WorksiteNameColumn from "@components/WorksiteNameColumn";
import Badge from "@ui-components/Badge";
import {UsersInvolved, Option} from "./types";
import {ModalOpenerButton} from "../../Resales/ModalOpenerButton";
import {UsersKpiTableFilter} from "./UserKpiTableFilter";


export const getColumns = (
  intl: any,
  countryCode: string,
  userMap: {[key: number]: string},
  userOptions: Option[],
  servicesMap: {[key: number]: string},
  setShowInvolvedUsersModal: (value: boolean | UsersInvolved) => void,
) => {

  return [
    {
      title: intl.formatMessage({id: "name"}),
      field: "address",
      type: "string",
      headerStyle: {minWidth: 150},
      cellStyle: {minWidth: 150, textTransform: "uppercase"},
      sorting: false,
      render: ({id, address, des_worksite, city}) => (
        <div className="font-semibold">
          <WorksiteNameColumn
            des_worksite={des_worksite}
            address={address}
            city={city}
            id={id}
            countryCode={countryCode}
          />
        </div>
      ),
    },
    {
      title: intl.formatMessage({id: "created_at", defaultMessage: "data di creazione"}),
      field: "created_at",
      type: "date",
      minWidth: 50,
      render: ({created_at}) => {
        return <span className={"text-xs"}>{new Date(created_at).toLocaleDateString("it-IT", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })}</span>;
      },
      filtering: false,
    },
    {
      title: intl.formatMessage({id: "specified_by", defaultMessage: "specificato da"}),
      field: "specifiers",
      minWidth: 200,
      filterComponent: (props) => <UsersKpiTableFilter
        {...props}
        userOptions={userOptions.filter(u=>u.label.endsWith('Field)'))}
      />,
      sorting: false,
      render: ({specifiers}) => {
        return specifiers.map((s) => userMap[s] || '').join(", ");
      }
    },
    {
      title: intl.formatMessage({id: "involved_users", defaultMessage: "utenti coinvolti"}),
      sorting: false,
      filtering: true,
      minWidth: 200,
      field: "users_involved",
      filterComponent: (props) => <UsersKpiTableFilter {...props} userOptions={userOptions} />,
      // created is a single user, shared is a list of users as well as visible
      render: ({users_involved}: UsersInvolved) => {
        const {created, shared, visible} = users_involved;
        return <>
          <ModalOpenerButton
            value={[
              ...(created ? [created] : []),
              ...(shared? shared : []),
              ...(visible? visible : []),
            ]}
            stateSetterFn={() => {
              const newValue: UsersInvolved = {
                created: created,
                shared: shared,
                visible: visible,
              }
              setShowInvolvedUsersModal(newValue);
            }}
          />
        </>
      }
    },
    {
      title: intl.formatMessage({
        id: "configurations",
        defaultMessage: "Configurazioni",
      }),
      field: "services",
      filtering: false,
      sorting: false,
      minWidth: 150,
      render: function (row) {
        return row["services"] ? (
          <div>
            {row["services"].map((s) =>
              s ? (
                <Badge
                  classNames="mb-1 mr-1"
                  text={servicesMap[s]}
                  key={s}
                  textSize="text-xxs"
                />
              ) : null
            )}
          </div>
        ) : null;
      },
    },
    {
      title: " #",
      width: 50,
      field: "num_surveys",
      type: "string",
      filtering: false,
      sorting: false,
      render: ({num_surveys}) => (
        <div className="font-semibold text-xl">{num_surveys}</div>
      ),
    },
    {
      title: intl.formatMessage({id:'specified_statuses', defaultMessage: 'Status specificati'}),
      type: "string",
      minWidth: 50,
      render: ({num_specified_surveys, num_won_surveys, num_lost_surveys}) => {
        // for each specified status > 0, show a badge with the number of surveys colored accordingly
        return (
          <div className="flex flex-col gap-2">
            {num_specified_surveys > 0 && (
              <Badge
                type={"neutral"}
                text={`${intl.formatMessage({id:'analytics_survey_specified'})}: ${num_specified_surveys}`}
                classNames="bg-gray-200 text-gray-800 text-xxs w-24"
              />
            )}
            {num_won_surveys > 0 && (
              <Badge
                type={"success"}
                text={`${intl.formatMessage({id:'analytics_survey_won'})}: ${num_won_surveys}`}
                classNames="bg-green-200 text-green-800 text-xxs w-24"
              />
            )}
            {num_lost_surveys > 0 && (
              <Badge
                type={"error"}
                text={`${intl.formatMessage({id:'analytics_survey_lost'})}: ${num_lost_surveys}`}
                classNames="bg-red-200 text-red-800 text-xxs w-24"
              />
            )}
          </div>
        );
      }
    },
    {
      title: intl.formatMessage({id: "value", defaultMessage: "Valore"}),
      field: "value",
      type: "string",
      filtering: false,
      render: ({value}) => (
        <div className="font-semibold text-lg">
          {intl.formatNumber(value, {
            style: "currency",
            currency: "EUR",
            maximumFractionDigits: 0,
          })}
        </div>
      ),
    },
  ]
}